module.exports = __webpack_public_path__ + "static/media/123.05bd41b1.webp";